import { apiClient } from '_shared/dataFetching/apiConfig';

export const playerService = {
  async updatePlayerHandedness({ matchId, playerId, handedness }) {
    const formData = new FormData();
    formData.append('player_id', playerId);
    formData.append('handedness', handedness);

    const headers = {
      'Content-Type': 'application/form-data',
      Username: localStorage?.userName
    };

    const url = `player/${playerId}/handedness`;
    const res = await apiClient.post(url, formData, { headers });
    return res.data;
  }
};
